import { getRouter } from './get-router';
/**
 * Gets the path for a specific route.
 * @param name - Name of the route.
 * @param params - Route path parameters.
 * @param router - Used router.
 * @returns Path for the route.
 */
export function urlFor(name, params, router = getRouter()) {
    var _a, _b;
    let path;
    try {
        path = (_a = router === null || router === void 0 ? void 0 : router.urlForName(name, params)) !== null && _a !== void 0 ? _a : '';
    }
    catch (error) {
        console.error(error);
        path = (_b = router === null || router === void 0 ? void 0 : router.urlForName('home')) !== null && _b !== void 0 ? _b : '';
    }
    return path;
}
